module.exports = __webpack_public_path__ + "static/media/1.ccb7550b.png";